module.exports = __webpack_public_path__ + "media/property_transaction_process/paragraph-dea83c52.svg";